/* Trovia Hero — reveal animations + subtle parallax (vanilla JS, no dependencies) */
(function () {
  'use strict';

  var prefersReducedMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initHero(hero) {
    var bgImg = hero.querySelector('.trovia-hero__bg-img');
    function markLoaded() {
      hero.classList.add('trovia-hero--loaded');
    }
    if (!bgImg) {
      markLoaded();
    } else if (bgImg.complete) {
      markLoaded();
    } else {
      bgImg.addEventListener('load', markLoaded, { once: true });
      bgImg.addEventListener('error', markLoaded, { once: true });
    }

    if (prefersReducedMotion) {
      hero.classList.add('trovia-hero--visible');
    } else if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              hero.classList.add('trovia-hero--visible');
              observer.unobserve(hero);
            }
          });
        },
        { threshold: 0.2 }
      );
      observer.observe(hero);
    } else {
      hero.classList.add('trovia-hero--visible');
    }

    if (!prefersReducedMotion) {
      var figures = hero.querySelector('[data-parallax]');
      if (figures) {
        var ticking = false;
        var maxShift = 18;

        var updateParallax = function () {
          ticking = false;
          var rect = hero.getBoundingClientRect();
          var viewportH = window.innerHeight || document.documentElement.clientHeight;

          var center = rect.top + rect.height / 2;
          var progress = (center - viewportH / 2) / (viewportH / 2 + rect.height / 2);
          progress = Math.max(-1, Math.min(1, progress));

          figures.style.transform = 'translateY(' + (progress * maxShift * -1) + 'px)';
        };

        var onScroll = function () {
          if (!ticking) {
            window.requestAnimationFrame(updateParallax);
            ticking = true;
          }
        };

        window.addEventListener('scroll', onScroll, { passive: true });
        window.addEventListener('resize', onScroll, { passive: true });
        updateParallax();
      }
    }
  }

  function init() {
    var heroes = document.querySelectorAll('[data-trovia-hero]');
    heroes.forEach(initHero);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var hero = event.target.querySelector('[data-trovia-hero]');
    if (hero) initHero(hero);
  });
})();
